<template>
  <ContentSection
    side-navigation="white"
    class="overflow-hidden"
    :class="!data.color_theme?.value || data.color_theme?.value === 'blue' ? `bg-theme-500 text-white` : `
      bg-theme-200
    `"
    :style="colorTheme"
  >
    <ul
      v-if="data.quotes.length"
      ref="sliderContainer"
      v-drag-scroll="{ dragSensitivity: 8 }"
      class="flex select-none gap-5"
    >
      <li
        v-for="quote in data.quotes"
        :key="quote.id"
        class="w-full shrink-0"
      >
        <Quote :data="quote" />
      </li>
    </ul>

    <!-- PAGINATION -->
    <!-- Uses the same spacing as the image to be positioned like the text -->
    <Container v-if="data.quotes.length > 1" indent="default-but-on-mobile-lg">
      <div class="relative mb-12 h-8">
        <PaginationSlider
          class="absolute -bottom-6 z-10 lg:-bottom-12 lg:left-96 lg:ml-10 lg:pl-20"
          :amount-pages="sliderContainer?.amountPages?.value || 1"
          :active-index="sliderContainer?.activeIndex?.value || 0"
          @scroll-to-item="sliderContainer?.scrollToItem ? sliderContainer?.scrollToItem($event) : null"
        />
      </div>
    </Container>
  </ContentSection>
</template>

<script lang="ts" setup>
import type { ComponentsMainQuotesFragment } from '#gql'
import type { DragElement } from '~/plugins/dragScroll'

const props = defineProps<{
  data: Enforce<ComponentsMainQuotesFragment>
  prevComponent?: string | null
  nextComponent?: string | null
}>()

const sliderContainer = ref<DragElement | null>(null)

const colorTheme = useGetColorThemeStylesComponent(props.data.color_theme?.value)
</script>
